import './constants'

export default {
  products: {
    state: {
      products: [],
    },
    getters: {
      products: (state) => state.products,

      /**
       * Attempts fo find the transactions related to the product
       * @param {String} idProduct Product id to search for
       * @returns {Array}
       */
      getProductTransactions(state, rootGetters) {
        return (idProduct) => {
          const transactions = rootGetters["transactions"];
          if (_.isEmpty(transactions)) return [];
          return transactions.filter((item) => item.id === idProduct);
        };
      },
    },
    mutations: {
      setProducts(state, newVal) {
        state.products = newVal;
      },
    },
    actions: {},
  },
};
